<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {metadata} from '@/store';
  import {closeExtendedMenu, extendedOptionStore, openExtendedMenu} from '../../ExtendedOptionMenu.svelte';
  import FontSelection from '../FontSelector/FontSelection.svelte';
  import FontEditor from '../FontEditor/FontEditor.svelte';
  import {attachPopup} from '../../PopupBox/PopupBox.svelte';
  import AnimationSelector from '../AnimationSelector/AnimationSelector.svelte';

  export let target: HTMLElement | string;
  let animSelectBtn: HTMLElement;
  let active = false;
  let colorBlock: HTMLElement;

  function changeFont() {
    if (!active)
      openExtendedMenu([
        {
          args: {
            target
          },
          component: FontSelection
        }
      ]);
    else closeExtendedMenu();
    active = !active;
  }

  function getTarget(): HTMLElement {
    if (typeof target == 'string') target = document.querySelector(target) as HTMLElement;
    return target;
  }

  function openAnimations() {
    attachPopup(animSelectBtn, AnimationSelector);
  }

  const unmount = extendedOptionStore.subscribe(store => {
    active = store.target ? true : false;
  });
  onMount(() => {
    if (typeof target === 'string') {
      target = document.querySelector(target) as HTMLElement;
    }
  });
  onDestroy(unmount);
</script>

<div class="flex w-full flex-col gap-4 rounded-bl-xl rounded-br-xl bg-zinc-100 p-4">
  <FontEditor advanced={false} target={getTarget()} colored={true} />
  <hr />
  <div class="flex w-full items-center">
    <p class="text-sm">Animation</p>
    <button
      class="ml-auto flex items-center justify-end gap-1 rounded-lg border border-gray-300 px-2 py-1"
      bind:this={animSelectBtn}
      on:click={openAnimations}
    >
      <span class="text-xs">Add Animation</span>
      <i class="fa-solid fa-chevron-right text-xs"></i>
    </button>
  </div>
</div>
